/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 音声分析処理のステータス（録音ダウンロード、詳細取得、文字起こしの統合ステータス）。succeededの場合は文字起こしデータが存在する。not_startedは音声分析が未開始の状態。
 * @export
 * @enum {string}
 */

export const VoiceAnalysisStatus = {
    NotStarted: 'not_started',
    Processing: 'processing',
    Succeeded: 'succeeded',
    Failed: 'failed'
} as const;

export type VoiceAnalysisStatus = typeof VoiceAnalysisStatus[keyof typeof VoiceAnalysisStatus];



